// import "./palette/palette.d.ts"
import "./palette/customPalette.d.ts"

import { createTheme, PaletteMode } from "@mui/material"
import { customTheme as designSystemTheme } from "ideep-design-system-2/theme"

import { MuiAccordion } from "~/theme/components/accordion/MuiAccordion"
import { MuiAccordionDetails } from "~/theme/components/accordion/MuiAccordionDetails"
import { MuiAccordionSummary } from "~/theme/components/accordion/MuiAccordionSummary"
import { MuiIconButton } from "~/theme/components/icon-button/MuiIconButton"
import { darkPalette } from "~/theme/palette/dark/darkPalette"
import { lightPalette } from "~/theme/palette/light/lightPalette"

const getDesignTokens = (mode: PaletteMode) => ({
  mode,
  ...(mode === "light" ? lightPalette : darkPalette),
})
const customTheme = (mode: PaletteMode, isRtl: boolean) =>
  createTheme({
    ...designSystemTheme(mode, isRtl),
    palette: getDesignTokens(mode),
    // typography
    components: {
      ...designSystemTheme(mode, isRtl).components,
      MuiAccordion,
      MuiAccordionSummary,
      MuiAccordionDetails,
      MuiButton: {
        ...designSystemTheme(mode, isRtl)?.components?.MuiButton,
      },
      MuiIconButton,
      // MuiAlert
    },
  })

export default customTheme
